import React from 'react';
import TextField from '@mui/material/TextField';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { useGlobalStore } from '../../../application/store/store';
import { Box } from '@mui/material';
import Note from './Note';
import Patient from './Patient';

const Referens = () => {
    // Access referensData and actions from the store
    const referensData = useGlobalStore((state) => state.referensData);
    const updateReferensField = useGlobalStore(
        (state) => state.updateReferensField
    );
    const resetReferensData = useGlobalStore(
        (state) => state.resetReferensData
    );
    const resetPatient = useGlobalStore((state) => state.resetPatient);
    const resetNote = useGlobalStore((state) => state.resetNote);

    const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        resetReferensData(); // Reset all fields when option changes
        resetPatient();
        resetNote();
        updateReferensField('selectedOption', e.target.value);
    };

    const handleInputChange = (value: string) => {
        updateReferensField('journalId', value);
    };

    return (
        <div className="flex flex-col w-full">
            <Box
                className="flex"
                sx={{
                    width: '100%',
                    textAlign: 'center',
                    px: { xs: 2, sm: 0 },
                }}
            >
                <div className="w-full md:w-1/2 flex flex-col mb-2">
                    <RadioGroup
                        value={referensData.selectedOption}
                        onChange={handleRadioChange}
                    >
                        <FormControlLabel
                            value="option1"
                            control={<Radio />}
                            label="Patient"
                        />
                        <FormControlLabel
                            value="option3"
                            control={<Radio />}
                            label="Kommentar"
                        />
                    </RadioGroup>
                </div>
                <div className="w-full md:w-1/2 flex flex-col mb-2">
                    <RadioGroup
                        value={referensData.selectedOption}
                        onChange={handleRadioChange}
                    >
                        <FormControlLabel
                            value="option2"
                            control={<Radio />}
                            label="Journal"
                        />
                    </RadioGroup>
                </div>
            </Box>
            {referensData.selectedOption && (
                <>
                    {referensData.selectedOption === 'option1' && (
                        <>
                            <Patient />
                            <Note label="kommentar" />
                        </>
                    )}
                    {referensData.selectedOption === 'option2' && (
                        <>
                            <Box
                                sx={{
                                    width: '100%',
                                    textAlign: 'center',
                                    px: { xs: 2, sm: 0 },
                                }}
                            >
                                <TextField
                                    fullWidth
                                    id="journalId"
                                    label="Journal-id"
                                    value={referensData.journalId || ''}
                                    onChange={(e) =>
                                        handleInputChange(e.target.value)
                                    }
                                    sx={{ mb: 2 }}
                                />
                            </Box>
                            <Note label="kommentar" />
                        </>
                    )}
                    {referensData.selectedOption === 'option3' && (
                        <Note label="kommentar" />
                    )}
                </>
            )}
        </div>
    );
};

export default Referens;
